import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import moment from 'moment-jalaali';

declare let $: any;

@Component({
  selector: 'share-video-modal',
  templateUrl: './share-video-modal.component.html',
  styleUrls: ['./share-video-modal.component.css'],
})
export class ShareVideoModalComponent implements AfterViewInit {
  @Input() modalId = 'share-video-modal';
  @Input() strUnitId = '';
  @ViewChild('modal') private modal!: ElementRef<HTMLDivElement>;
  @ViewChild('startTime') private startTime!: ElementRef<HTMLInputElement>;
  @ViewChild('endTime') private endTime!: ElementRef<HTMLInputElement>;

  bEditMode = false;
  mdlTempAccess: FormGroup = this.FormBuilder.group({
    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
    strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

    strUnitID: new FormControl(''),

    iTemporaryAccess: new FormControl(''),

    strSDate: new FormControl('', Validators.required),

    strSTime: new FormControl('', Validators.required),

    strEDate: new FormControl('', Validators.required),

    strETime: new FormControl('', Validators.required),

    strMobile: new FormControl('', Validators.required),

    strPassword: new FormControl('', Validators.required),
  });

  constructor(
    private FormBuilder: FormBuilder,
    private gurdService: GurdServiceService,
    private tooltip: NotificationService,
    private otherService: OtherService,
  ) {}

  ngAfterViewInit(): void {
    this.mdlTempAccess.patchValue({ strUnitID: this.strUnitId.split('-')[0] });
    $(this.modal.nativeElement).find('.clockpicker').clockpicker({
      donetext: 'top',
      align: 'top',
      autoclose: true,
    });
  }

  open(): void {
    this.mdlTempAccess.patchValue({
      strUnitID: this.strUnitId.split('-')[0],
      strSDate: moment().format('jYYYY/jMM/jDD'),
      strSTime: moment().format('HH:mm'),
      strEDate: moment().format('jYYYY/jMM/jDD'),
      strETime: '23:59',
      strMobile: '',
      strPassword: '',
    });
    $(this.modal.nativeElement).modal('show');
  }

  async new_TempAccess() {
    const Stime = this.startTime.nativeElement;

    const Etime = this.endTime.nativeElement;

    const strSTime = moment(Stime.value.trim(), 'HH:mm').format('HH:mm');

    this.mdlTempAccess.get('strSTime')?.setValue(Stime.value);

    this.mdlTempAccess.get('strETime')?.setValue(Etime.value);

    if (this.mdlTempAccess.invalid)
      return this.tooltip.showError('لطفا فرم را با دقت تکمیل کنید');

    if (
      moment(
        this.mdlTempAccess.get('strSDate')?.value.trim(),
        'jYYYY/jMM/jDD',
      ).isBefore(moment(), 'day')
    ) {
      return this.tooltip.showError('تاریخ شروع نمی تواند قبل از امروز باشد');
    }

    if (
      moment(
        this.mdlTempAccess.get('strEDate')?.value.trim(),
        'jYYYY/jMM/jDD',
      ).isBefore(moment(), 'day')
    ) {
      return this.tooltip.showError('تاریخ پایان نمی تواند قبل از امروز باشد');
    }

    if (
      moment(
        this.mdlTempAccess.get('strEDate')?.value.trim(),
        'jYYYY/jMM/jDD',
      ).isBefore(
        moment(
          this.mdlTempAccess.get('strSDate')?.value.trim(),
          'jYYYY/jMM/jDD',
        ),
      )
    ) {
      return this.tooltip.showError(
        'تاریخ پایان نمی تواند قبل از تاریخ شروع باشد',
      );
    }

    if (
      moment(strSTime, 'HH:mm').isBefore(
        moment(moment().format('HH:mm'), 'HH:mm'),
      )
    ) {
      return this.tooltip.showError(
        `ساعت شروع نمی تواند گذشته باشد. (زمان فعلی : ${moment().format('HH:mm')})`,
      );
    }

    if (this.mdlTempAccess.get('strMobile')?.value.length < 10)
      return this.tooltip.showError('لطفا شماره موبایل را به درستی وارد کنید');

    this.otherService.Showspinner();

    try {
      const resp = await axios.post(
        `TemporaryAccess_Save`,
        this.otherService.stringNumberToNumber(this.mdlTempAccess.value),
      );

      const res = JSON.parse(resp.data);

      if (res.iResult == 0) return this.tooltip.showError(res.strError);

      this.tooltip.showSuccess('با موفقیت ثبت شد');

      $(this.modal.nativeElement).modal('hide');
    } catch {
      this.tooltip.showError('خطا در ذخیره اشتراک فیلم');
    } finally {
      this.otherService.nonespinner();
    }
  }

}
